import Virus from './Virus.js';
import Medical from './Medical.js';

export {
    Virus,
    Medical,
}; 